import api from '../api';

import { ParamsBodyChangeBillingPaymentMethod } from 'utils/typeServices';

export const PostChangeBillingPaymentMethod = async ({ token, body }: { token: string, body: ParamsBodyChangeBillingPaymentMethod }) => {
    const bodyJson = JSON.stringify(body);

    try {
        const { data } = await api.post<{ Data: any }>('v1/Pagamento/ChangeBillingPaymentMethod', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error: any) {
        if (error?.response?.data?.ErrorCode === "excecao_prazo_nova_alteracao_cobranca") {
            return { data: false };
        }
        return { data: null };
    }
}
